import { useEffect, useState } from 'react'

import Auth from 'store/auth'

import { getAxiosArr } from 'pages/api/axios'
import { concatParams } from 'utils/getURLData'
import { BASE_URL } from 'constants/url'
import { skeletonFour } from 'constants/skeleton-data'
import { IMaterial } from 'constants/types/webinar.types'

const InitData = {
  cards: (skeletonFour as IMaterial[]) || (skeletonFour as any),
  isLoaded: false,
}

const useRecommendation = (materialId: number, materialType: string, limit?: number) => {
  const [recommendations, setRecommend] = useState(InitData)
  const { isAuthorized } = Auth.useAuth()

  useEffect(() => {
    const getData = async () => {
      const formedParams = concatParams({
        materialId: String(materialId),
        materialType,
        limit: String(limit),
      })
      const url = `${BASE_URL.RECOMMENDATION}?${formedParams}`
      const cards = await getAxiosArr(url)
      setRecommend({ cards, isLoaded: true })
    }
    if (materialId) {
      getData()
    }
  }, [materialId])

  return { recommendations, setRecommend, materialType }
}

export default useRecommendation
